import { v4 } from 'uuid'
import { ItemData } from 'store/types'
import { faIcons } from '@fortawesome/free-solid-svg-icons'

export const createText = (): ItemData<'text'> => ({
  type: 'text',
  id: v4(),
  loaded: false,
  baseProps: {
    borderColor: '#fff',
    borderWidth: '1%',
    borderRadius: 8
  },
  props: {
    text: 'Texto',
    backgroundColor: '#D3D3D3',
    color: '#000',
    bold: false,
    italic: false,
    underline: false,
    lineThrough: false
  },
  zIndex: 0,
  x: 50,
  y: 50,
  lastParentWidth: 0,
  lastParentHeight: 0,
  height: '20%',
  width: '50%'
})

export const createImage = (): ItemData<'image'> => ({
  type: 'image',
  id: v4(),
  loaded: false,
  baseProps: {
    borderColor: '#fff',
    borderWidth: '0%',
    borderRadius: 0
  },
  props: {
    backgroundColor: 'transparent'
  },
  zIndex: 0,
  x: 50,
  y: 50,
  lastParentWidth: 0,
  lastParentHeight: 0,
  height: '20%',
  width: '50%'
})

export const createShape = (): ItemData<'shape'> => ({
  type: 'shape',
  id: v4(),
  loaded: false,
  baseProps: {
    borderColor: '#fff',
    borderWidth: '0%',
    borderRadius: 0
  },
  props: {
    color: '#000',
    name: 'icons',
    icon: faIcons
  },
  zIndex: 0,
  x: 50,
  y: 50,
  lastParentWidth: 0,
  lastParentHeight: 0,
  height: '20%',
  width: '50%'
})
